<template>
  <div class="connection-modal" ref="connectionModal">
    <a-modal  v-model:open="configs.waitingOpen" :closable="false" :width="720" :getContainer="() => connectionModal"
      :destroyOnClose="true" :maskClosable="false" :footer="null">
      <div class="content">
        <div class="loading">
          <a-spin size="large" />
          <p>{{ $t('seller.dashboard.profilePleaseWait') }}<br />{{ $t('seller.dashboard.profilePleaseWaitSub') }}</p>
        </div>
        <p class="note">{{ $t('seller.dashboard.profileNoticeCache') }}</p>
        <div class="qrcodes-modal-wrapper" ref="qrcodes">
          <div class="qrcodes">
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../assets/images/social-media-qrcode/slack.png" alt="Slack QR Code" />
                <p>{{ $t('seller.dashboard.profileScanQr') }}</p>
              </template>
              <svg class="icon slack" aria-hidden="true" style="fill: #fff">
                <use xlink:href="#icon-slack" />
              </svg>
            </a-popover>
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../assets/images/social-media-qrcode/whatsapp.png" alt="whatsapp QR Code" />
                <p>{{ $t('seller.dashboard.profileScanQr') }}</p>
              </template>
              <i class="iconfont icon-whatsapp" />
            </a-popover>
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../assets/images/social-media-qrcode/wechat.png" alt="Wechat QR Code" />
                <p>{{ $t('seller.dashboard.profileScanQr') }}</p>
              </template>
              <i class="iconfont icon-wechat" />
            </a-popover>
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../assets/images/social-media-qrcode/lark.png" alt="Lark QR Code" />
                <p>{{ $t('seller.dashboard.profileScanQr') }}</p>
              </template>
              <svg class="icon lark" aria-hidden="true" style="fill: #fff">
                <use xlink:href="#icon-lark" />
              </svg>
            </a-popover>
          </div>
        </div>
      </div>
      <template #title>
        <div class="modal-title">{{ $t('seller.dashboard.profileConnectingAmazon') }}</div>
      </template>
    </a-modal>
    <a-modal v-model:open="configs.isOldUser" :closable="false" :width="650" :getContainer="() => connectionModal"
      :destroyOnClose="true" :maskClosable="false" :footer="null">
      <div class="old-content">
        <div>
          {{ $t('seller.dashboard.profileOldUser1') }}
        </div>
        <div class="text">
          {{ $t('seller.dashboard.profileOldUser2') }}
        </div>
        <div class="confirm">
          {{ $t('seller.dashboard.profileOldUserConfirm') }}
        </div>
        <div class="amazon-button">
          <a id="LoginWithAmazon" @click.prevent="onSubmit">
            <img border="0" alt="Login with Amazon"
              src="http://g-ecx.images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64._CB372226922_.png" />
          </a>
        </div>
      </div>
      <template #title>
        <div class="modal-title">{{ $t('seller.dashboard.profileReconnectTitle') }}</div>
      </template>
    </a-modal>
    <artmisads-modal v-model:open="configs.isFailed" :width="600" :getContainer="() => connectionModal" :footer="null"
      @cancel="setModalType('fail')">
      <div class="failed-content">
        <div>
          {{ $t('seller.dashboard.profileFailed1') }}
        </div>
        <div>
          {{ $t('seller.dashboard.profileFailed2') }}
        </div>
        <div class="account">
          <span v-for="(name, index) in configs.data" :key="index">
            {{ name }};
          </span>
        </div>
        <div>{{ $t('seller.dashboard.profileFailedHelp') }} </div>
        <div>
          <a class="email">Support@ArtemisAds.com</a>
        </div>
      </div>
      <template #title>
        <div class="modal-title">{{ $t('seller.dashboard.profileConnectionFailed') }}</div>
      </template>
    </artmisads-modal>
    <div id="amazon-root"></div>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
const { configs } = defineProps(["configs"]);
const emit = defineEmits(['change', 'bind'])
const route = useRoute();
const router = useRouter();
const connectionModal = ref();
onMounted(() => {
  amazonLoginInitialize();
  const amazonAuthorizationCode = route?.query?.code;
  if (amazonAuthorizationCode) {
    router.replace({ name: route.name });
    emit('bind', amazonAuthorizationCode);
  }
});
function amazonLoginInitialize() {
  const CLIENT_ID =
    "amzn1.application-oa2-client.d1775637c50f46d4b039895ab42f2dda";
  window.onAmazonLoginReady = function () {
    amazon.Login.setClientId(CLIENT_ID);
  };
  (function (d) {
    var a = d.createElement("script");
    a.type = "text/javascript";
    a.async = true;
    a.id = "amazon-login-sdk";
    a.src = "https://assets.loginwithamazon.com/sdk/na/login1.js";
    d.getElementById("amazon-root").appendChild(a);
  })(document);
}
function onSubmit() {
  const options = {};
  options.scope = "advertising::campaign_management profile";
  options.response_type = "code";
  // options.popup = false;
  amazon.Login.authorize(options, `${location.origin}/seller/dashboard`);
  return false;
}
const setModalType = (type) => {
  emit('change', type)
}
</script>
<style lang="less" scoped>
.connection-modal {
  z-index: 1000;
  position: relative;
  .modal-title {
    font-size: 32px;
    text-align: center;
  }

  .content {
    width: 100%;
    display: flex;
    border-radius: 8px;
    align-items: center;
    flex-direction: column;
    background: var(--color-white);

    .loading {
      width: 100%;
      padding: 72px 0;
      text-align: center;
      border-radius: 8px;
      background-color: #f8f7fc;

      >p {
        height: 40px;
        margin-top: 16px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        color: var(--dark-2);
        letter-spacing: 0.4px;
      }
    }

    .note {
      width: 100%;
      height: 20px;
      font-size: 13px;
      margin-top: 24px;
      margin-bottom: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
    }
  }

  .old-content {
    .text {
      margin: 16px 0;
    }

    .confirm {
      margin-bottom: 24px;
      color: var(--error-1);
    }

    .amazon-button {
      display: flex;
      align-items: center;
      justify-content: center;

      >a {
        display: block;
        width: 195px;
        height: 40px;
        border-radius: 2px;
        text-align: center;
        margin-right: 8px;

        >img {
          width: 193px;
          height: 40px;
        }
      }
    }
  }

  .failed-content {
    margin-bottom: 16px;

    .account {
      margin: 24px 0;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      >span {
        margin-right: 10px;
        font-size: 20px;
        font-weight: 500;
      }
    }

    .email {
      text-decoration: underline;
      color: var(--dark-2);
      font-weight: 500;

      &:hover {
        color: var(--dark-1);
      }
    }
  }

  .qrcodes-modal-wrapper {
    width: 100%;

    img {
      width: 112px;
    }

    :deep(.ant-popover-inner) {
      padding: 10px;

      &-content>p {
        height: 16px;
        font-size: 11px;
        margin-top: 7px;
        line-height: 16px;
        text-align: center;
        color: var(--dark-4);
        letter-spacing: 0.28px;
      }
    }
  }

  .qrcodes {
    gap: 16px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon,
    .iconfont {
      width: 32px;
      height: 32px;
      padding: 4px;
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #E8E5ED;
    }

    .iconfont {
      color: #fff;
      font-size: 24px;
      font-weight: normal;
      background-color: #25D366;

      &::before {
        display: block;
        margin-top: -7px;
        margin-left: -1px;
      }
    }
  }
}
</style>
